import { Button, ButtonProps } from '@ui/lib/park/ui/button';
import { useTranslation } from 'next-i18next';
import { Flex, FlexProps, Stack } from 'styled-system/jsx';

import { useMarketStatus } from '../../../hooks/useMarketStatus';
import { MarketStatusMessage } from '../MarketStatusMessage';
import { useIsLong } from '../store/useIsLong';

export const TradeButton = ({
  setIsTradeModuleOpen,
  ...p
}: FlexProps & {
  setIsTradeModuleOpen: (isOpen: boolean) => void;
}) => {
  const status = useMarketStatus();
  const setIsLong = useIsLong((s) => s.setPersistValue);
  
return (
    <Stack {...p} bgColor="greyWhite.darkGary1">
      <Flex gap={2}>
        <TradeActionButton
          text="Long"
          disabled={status.isDisabled || status.long?.isDisabled}
          colorPalette="priceUp"
          onClick={() => {
            setIsLong(true);
            setIsTradeModuleOpen(true);
          }}
        />
        <TradeActionButton
          text="Short"
          disabled={status.isDisabled || status.short?.isDisabled}
          colorPalette="priceDown"
          onClick={() => {
            setIsLong(false);
            setIsTradeModuleOpen(true);
          }}
        />
      </Flex>

      <MarketStatusMessage status={status} isLong={null} />
    </Stack>
  );
};

interface TradeButtonProps extends ButtonProps {
  text: string;
  colorPalette: string;
}

const TradeActionButton = ({
  text,
  disabled,
  colorPalette,
  onClick,
}: TradeButtonProps) => {
  // const { t } = useTranslation();

  return (
    <Button
      textStyle="headings.small"
      borderRadius="4px"
      flex={1}
      minH="44px"
      variant="solid"
      cursor={disabled ? 'not-allowed' : 'pointer'}
      opacity={disabled ? 0.4 : 1}
      colorPalette={colorPalette}
      onClick={disabled ? undefined : onClick}
      bgColor={
        colorPalette === 'priceUp'
          ? 'var(--colors-price-price-up)'
          : 'var(--colors-price-price-down)'
      }
    >
      {text}
    </Button>
  );
};
